module.exports = __webpack_public_path__ + "media/markers/logimg_C-92d714c0.png";